(function () {
    "use strict";

    angular.module("gardaSee", [

            // import module inetcons url Service
            "inetconsFilterServices"
        ])
        .controller("enquiryController", [
            "$scope", "$document", "accosHashUrlService", "cookie",
            function ($scope, $document, accosHashUrlService, cookie) {

                var boardingIds = [];
                var amenityIds = [];
                $scope.accotypeCounts = {};
                $scope.areaCounts = {};
                $scope.boardingCounts = {};
                $scope.amenityCounts = {};
                $scope.countAll = null;

                var callbackCounts = function (enquiryCount) {
                    $scope.$apply(function() {
                        $scope.accotypeCounts = enquiryCount.accoTypeCounts;
                        $scope.areaCounts = enquiryCount.areaCounts;
                        $scope.boardingCounts = enquiryCount.boardingCounts;
                        $scope.amenityCounts = enquiryCount.amenityCounts;
                        $scope.countAll = enquiryCount.count;
                    });
                }

                $document.ready(function() {

                    // Boardings
                    var boardingLis = angular.element(".js-boarding-ul").children();
                    angular.forEach(boardingLis, function (li) {
                        li = angular.element(li);

                        var id = li.attr("boarding-id");
                        var url = li.attr("boarding-url");
                        if (li.find(".item").hasClass("active")) {
                            boardingIds.push(id);
                        }
                        accosHashUrlService.addBoardingSet(id, url, function callbackChangeState(isActive) {
                            li.find(".item").toggleClass("active", isActive);
                        });

                        li.bind("click", function () {
                            var item = li.find(".item");
                            var id = li.attr("boarding-id");
                            if (!item.hasClass("active") && item.hasClass("disabled")) {
                                return;
                            }
                            var isActive = item.toggleClass("active").hasClass("active");

                            if (isActive) {
                                boardingIds.push(id);
                            } else {
                                var index = boardingIds.indexOf(id);
                                boardingIds.splice(index, 1);
                            }

                            accosHashUrlService.gotofilterUrl(boardingIds, amenityIds);
                            if (typeof UpdateCompanyCount === "function") UpdateCompanyCount(amenityIds, boardingIds, callbackCounts); // enquiry.js
                        });
                    });


                    // Amenities
                    var amenityDivs = angular.element(".js-amenity-div").children();
                    angular.forEach(amenityDivs, function(div) {
                        var checkBox = angular.element(div).find(":checkbox");

                        var id = checkBox.attr("amenity-id");
                        var url = checkBox.attr("amenity-url");
                        if (checkBox.prop('checked')) {
                            amenityIds.push(id);
                        }
                        accosHashUrlService.addAmenitySet(id, url, function callbackChangeState(isActive) {
                            checkBox.prop("checked", isActive);
                        });

                        checkBox.bind("change", function() {
                            var id = checkBox.attr("amenity-id");
                            if (checkBox.is(":checked")) {
                                amenityIds.push(id);
                            } else {
                                var index = amenityIds.indexOf(id);
                                amenityIds.splice(index, 1);
                            }
                            accosHashUrlService.gotofilterUrl(boardingIds, amenityIds);
                            if (typeof UpdateCompanyCount === "function") UpdateCompanyCount(amenityIds, boardingIds, callbackCounts); // enquiry.js
                        });
                    });



                    // init
                    function initFilter() {
                        var accoFiltersettings = accosHashUrlService.parseUrl();
                        if (accoFiltersettings != undefined) {
                            boardingIds = accoFiltersettings.boardingIds;
                            amenityIds = accoFiltersettings.amenityIds;
                        }

                        UpdateCompanyCount(amenityIds, boardingIds, callbackCounts); // enquiry.js
                    }

                    cookie.onChanged('accosUrlService', function () {
                        initFilter();
                    });
                    $scope.$apply(function () {
                        // on ready, from enquiry.js
                        $('#AreaId, #ThemeId, [name="AccotypeIds"]').change(function () {
                            UpdateCompanyCount(amenityIds, boardingIds, callbackCounts); // enquiry.js
                        });

                        initFilter();
                    });

                });

            }
        ])
        .directive("areaSerach", [
            "$timeout",
            function ($timeout) {
                return {
                    link: function ($scope, $element, $attr) {
                        var par = $element.parent();
                        var areaSelect = par.find("select#AreaId");
                        var areaItems = par.find("li#area-list-item");
                        var id = parseInt(areaSelect.val()); // string.Empty -> NaN

                        $scope.area = {
                            serach: "",
                            clear: function () {
                                this.search = "";
                            },
                            select: function (event, id) {
                                areaItems.removeClass("active");
                                areaSelect.val(id).trigger("change").click();

                                angular.element(event.currentTarget).addClass("active");
                            }
                        }
                        $scope.$watch("area.search", function (value) {
                            if (typeof value == "undefined") return;
                            var regex = new RegExp("^.*" + value + ".*", "i");
                            var first = 1;

                            areaItems.each(function () {
                                var e = $(this);

                                var isMatch =
                                    regex.test(e.data("normalized")) || // combare without diacritics
                                    regex.test(e.text());

                                if (isMatch) {
                                    e.show();
                                    if (first) {
                                        first = 0;
                                        e.addClass("active");
                                        id = e.data("id");
                                    } else {
                                        e.removeClass("active");
                                    }
                                } else {
                                    e.hide().removeClass("active");
                                }
                            });
                            areaSelect.val(id).trigger("change");
                        });

                        areaItems.filter(function (i, e) { return +$(e).data("id") === id; }).addClass("active");
                        $timeout(function() {
                            par.find(".filter-list").scrollTo("#area-list-item.active", 300, { offset: 0 });
                        });

                    }
                }
            }
        ]);

})();
